<template>
  <el-dialog
    top="0"
    custom-class="rizhi"
    :before-close="handleClose"
    :visible.sync="rizhiDialogVisible"
    width="30%"
    center
  >
    <div slot="title" class="dialog-title">
      <span class="title-inheader">更新日志</span>
    </div>
    <div class="journal">
      <div class="journal-day" v-for="(item, index) in logLists" :key="index">
        <span class="time">{{ item.updateTime }} </span>
        <div class="content">
          <p class="version">{{ item.version }}</p>
          <span
            class="sub-title"
            v-for="(subItem, subIndex) in item.subBody"
            :key="subIndex"
            >{{ subItem }}</span
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import yuqueClient from "@/utils/yuqueClient";
// import SDK from "@yuque/sdk";
// const client = new SDK({
//   token: "Ru09RtNrMGOXUKSxVkb88gr9rMZ27bCYaFbpaEHa",
//   // other options
// });
// const SDK = require("@yuque/sdk");
export default {
  props: {
    rizhiDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 显示的数据
      bodyHtml: "",
      logLists: [],
    };
  },
  methods: {
    handleClose() {
      this.$emit("closeModal");
    },
  },
  async mounted() {
    let logLists = [];
    let { data } = await yuqueClient.get(
      "/v2/repos/bq9rk1/product/docs/yrmibf",
      {
        raw: 1,
      }
    );
    let replaceBody = data.data.body.replace(/<a[a-zA-Z\s\w="'\\>]+<\/a>/g, "");
    replaceBody = replaceBody.replace(/(#+)\s+(v[\w.]+)/g, "$2");
    replaceBody = replaceBody.split(/[\n]/).filter((item) => Boolean(item));
    for (let i = 0; i < replaceBody.length - 1; i = i + 2) {
      let itemLog = {};
      itemLog.version = replaceBody[i];
      let subBody = replaceBody[i + 1]
        .split("<br />")
        .filter((item) => Boolean(item));
      let updateTime = subBody[0].replace(/更新日期：/, "");
      updateTime = updateTime.match(/([\u4E00-\u9FFF\w]+日)/g)[0];
      // console.log("match", match);
      itemLog.updateTime = updateTime;
      subBody = subBody.slice(1);
      itemLog.subBody = subBody;
      logLists.push(itemLog);
    }
    this.logLists = logLists;
  },
};
</script>
<style scoped lang="scss">
.journal {
  width: 100%;
  height: 500px;
  overflow: auto;
  .journal-day {
    position: relative;
    padding-left: 133px;
    .time {
      position: absolute;
      left: -1px;
      top: 26px;
      height: 26px;
      line-height: 26px;
      width: 134px;
      text-align: left;
      padding-left: 22px;
      font-size: 14px;
      color: #80848b;
      background: #fff;
      z-index: 2;
    }
    .content {
      padding: 26px 31px 21px 0;
      position: relative;
      text-align: left;
      &:before {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: #e6e7e9;
        width: 1px;
        content: "";
      }
      .version {
        position: relative;
        padding-left: 32px;
        font-size: 14px;
        font-weight: 700;
        color: #333;
        height: 26px;
        line-height: 26px;
        z-index: 2;
        &:before,
        &:after {
          position: absolute;
          content: "";
          top: 50%;
          transform: translateY(-50%);
          border-radius: 14px;
        }
        &:before {
          left: -5px;
          width: 9px;
          height: 9px;
          border: 1px solid #0057ff;
          background: #fff;
        }
        &:after {
          left: -2px;
          width: 5px;
          height: 5px;
          background: #0057ff;
        }
      }

      span {
        text-indent: 1em;
        display: block;
        padding-left: 32px;
        margin-top: 10px;
        font-size: 14px;
        color: #80848b;
        line-height: 1.2;
        &.sub-title {
          text-indent: 0em;
        }
        &.summary {
          line-height: 1.4;
          // display: block;
          margin-top: 20px;
          // color: #333;
        }
      }
    }
  }
}
::v-deep .rizhi {
  width: 708px !important;
  max-height: 620px;
  .el-dialog__body {
    padding: 0;
    max-height: 546px;
    // height: 500px;
    overflow-y: auto;
    // overflow: auto;
    overflow-x: hidden;
  }
}
</style>
